import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { FB_COLLECTION_PATH } from "./postActionTypes";

export interface JobEditUpdates {
  shiftIdentifier: string;
  company: string;
  location: string;
  locationCoordinates: string;
  pay: string;
  shiftNotes: string;
  numJobSlots: number;
  dateTimeStart?: string | null;
  dateTimeFinish?: string | null;
}

export interface SchedulerProfile {
  firstName: string;
  userId: string;
}

/**
 * Trigger async job edit processing via cloud function.
 * Writes to pending collection which triggers cloud function to process edits in background.
 * 
 * @param schedulerUID - The scheduler's user ID
 * @param jobId - The job ID (uniqueJobId) being edited
 * @param seriesId - The series ID if editing a series, null for single job
 * @param editScope - "single" or "series" to indicate edit scope
 * @param updates - Object containing the field updates to apply
 * @param schedulerProfile - Scheduler profile info for notifications
 * @returns Promise with status
 */
export async function fx_FB_JobEditPending(
  schedulerUID: string,
  jobId: string,
  seriesId: string | null,
  editScope: "single" | "series",
  updates: JobEditUpdates,
  schedulerProfile: SchedulerProfile
) {
  const userRef = collection(db, FB_COLLECTION_PATH.Users);
  
  await addDoc(collection(userRef, schedulerUID, "jobEditPending"), {
    EditInfo: {
      schedulerUID,
      jobId,
      seriesId,
      editScope,
      updates,
      schedulerProfile,
      timestamp: Date.now(),
    },
  });
  
  return { status: "pending" };
}
